import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobileBank from "./MobileBank";
import DesktopBank from "./DesktopBank";

const BankAddressPage = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobileBank />;

  return <DesktopBank />;
});

export default BankAddressPage;
